module.exports = __webpack_public_path__ + "static/media/play-stone-player.4c22bcce.png";